import { gql } from '@apollo/client';

export const UPDATE_COMPANY_META_PRICING = gql`
mutation updateCompanyMetaPricing($data:pricingObject ){
  updateCompanyMetaPricing(data:$data )
}

`